export const STATUS_ADMIN_REPORTS = {
  PROCESSING: 'PROCESSING',
  DONE: 'DONE',
};

export const STATUS_UPLOAD_VIDEO = {
  PROCESSING: 'PROCESSING',
  COMPLETE: 'COMPLETE',
};
